import { useTranslation } from 'next-i18next'
import { GetServerSidePropsContext } from 'next'

import Meta from '@/components/Meta'

import Hero from '@/components/landing/saudiExpo/Hero'
import FormSection from '@/components/landing/saudiExpo/FormSection'
import KnowSection from '@/components/landing/saudiExpo/KnowSection'
import MoreSection from '@/components/landing/saudiExpo/MoreSection'
import TouchSection from '@/components/landing/saudiExpo/TouchSection'
import LandingLayout from '@/components/layouts/LandingWithLang'
import { loadTranslationsWithMarket } from '@/utils/loadTranslations'

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  return loadTranslationsWithMarket(context, {
    cache: 'stale-while-revalidate',
    namespaces: ['common', 'landing', 'faq']
  })
}

function SaudiExpo() {
  const { t } = useTranslation('landing')

  return (
    <LandingLayout>
      <Meta
        title={t('saudiExpo.meta.title')}
        description={t('saudiExpo.meta.description')}
        withoutPostfix
      />
      <Hero />
      <KnowSection />
      <TouchSection />
      <MoreSection />
      <FormSection />
    </LandingLayout>
  )
}

export default SaudiExpo
